var _path, _path2, _path3, _path4, _path5, _path6, _tspan, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPdf = function SvgPdf(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "PDF",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_1352)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5436 26.6348C26.5436 27.9145 25.5143 28.9519 24.2447 28.9519H8.43986C7.17023 28.9519 6.14099 27.9145 6.14099 26.6348V5.31712C6.14099 4.03742 7.17023 3 8.43986 3H18.2789C18.7368 3 19.1759 3.18359 19.4993 3.51032L26.0399 10.1169C26.3624 10.4427 26.5436 10.8842 26.5436 11.3444V26.6348Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99069 28.9519H8.43966C7.17038 28.9519 6.14099 27.9143 6.14099 26.6345V5.31737C6.14099 4.03757 7.17038 3 8.43966 3H9.99069C8.72141 3 7.69202 4.03757 7.69202 5.31737V26.6345C7.69202 27.9143 8.72141 28.9519 9.99069 28.9519Z",
    fill: "#CED0D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5436 11.3443V12.1923H20.5482C18.8358 12.1923 17.443 10.7851 17.443 9.05561V3H18.279C18.7366 3 19.1761 3.18379 19.4992 3.51017L26.0399 10.1167C26.3626 10.4425 26.5436 10.8843 26.5436 11.3443Z",
    fill: "#CED0D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.389 10.6258H20.5482C19.69 10.6258 18.9941 9.92296 18.9941 9.0556V3.15717C19.1807 3.24227 19.3519 3.36133 19.4992 3.51015L26.04 10.1167C26.1873 10.2655 26.3047 10.4378 26.389 10.6258Z",
    fill: "#DC4955"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5969 25.5056H7.08771C5.94556 25.5056 5.01965 24.5704 5.01965 23.4169V15.7932C5.01965 14.6397 5.94561 13.7045 7.08771 13.7045H25.597C26.7391 13.7045 27.665 14.6397 27.665 15.7932V23.4169C27.665 24.5705 26.7391 25.5056 25.5969 25.5056Z",
    fill: "#DC4955"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38023 25.5056H7.08771C5.94561 25.5056 5.01965 24.5704 5.01965 23.4169V15.7932C5.01965 14.6397 5.94566 13.7045 7.08771 13.7045H8.38028C7.23817 13.7045 6.31222 14.6398 6.31222 15.7932V23.4169C6.31217 24.5704 7.23812 25.5056 8.38023 25.5056Z",
    fill: "#C42430"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Helvetica Neue",
    fontSize: 8,
    letterSpacing: "0.8px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 8.27422,
    y: 22.032
  }, "PDF")))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_1352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 26,
    fill: "white",
    transform: "translate(5 3)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pdf.9711364423e4975e4bdabc7e4071c6bc.svg";